import { generateTestId } from "@client-shared";

export const setSsBagSizeProductSearchModalTestId = (identifier: string): string =>
  generateTestId("SsBagSizeProductSearchModal", identifier);
